import { getTestAttributes } from '@chillibean/component-library';
import PropTypes from 'prop-types';

function IconButton(props) {
  const { icon, size, colour, viewBox, handleClick, testID = '' } = props;
  const handleOnClick = (event) => handleClick && handleClick(event);

  return (
    <div
      className="iconButton"
      onClick={(event) => {
        handleOnClick(event);
      }}
      {...getTestAttributes(testID)}
    >
      {icon(size, size, colour, viewBox)}
    </div>
  );
}

IconButton.propTypes = {
  size: PropTypes.number,
  colour: PropTypes.string,
  viewBox: PropTypes.string,
  icon: PropTypes.func.isRequired,
  handleClick: PropTypes.func,
  testID: PropTypes.string,
};

export default IconButton;
